import React from "react";
import { ExchangeOptionOtherItems } from "../Components";

export const OtherItems = () => {
  return <ExchangeOptionOtherItems />;
};
